import type { AppLink } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';
import type { AppLinkState, AppLinkError } from '../../entities/applink/types.tsx';
import type { State } from '../../types.tsx';

export const getAppLinkState = (state: State): AppLinkState | undefined => state.entities.appLink;
export const getAppLink = (state: State): AppLink | undefined => state.entities.appLink?.appLink;
export const getIsAppLinkLoaded = (state: State): boolean =>
	state.entities.appLink?.isLoaded || false;

export const getAppLinkOrError = (state: State): AppLink | AppLinkError | undefined => {
	const { isLoaded, error, appLink } = state.entities.appLink || {};
	if (isLoaded && appLink) {
		return appLink;
	}
	if (error) {
		return { error };
	}
	return undefined;
};
